import { getCategorySearchRequestBody } from "components/search-bar/open-search-filter-request-builder";
import { getBasicQueryString } from "components/search-bar/search-filter-query-strings";
import { Features } from "modules/auth/Authorization";

const extractBracketedAndNonBracketed = (filterValue) => {
  const insideBracketsText = [];
  const outsideBracketsText = [];

  let regex = /\(([^()]*)\)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(filterValue)) !== null) {
    if (match.index > lastIndex) {
      outsideBracketsText.push(
        filterValue.slice(lastIndex, match.index).trim(),
      );
    }

    insideBracketsText.push(match[1]);

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < filterValue.length) {
    outsideBracketsText.push(filterValue.slice(lastIndex).trim());
  }

  return [...insideBracketsText, ...outsideBracketsText];
};

export const SEARCH_CATEGORIES_OPEN_SEARCH = [
  {
    queryKey: "vinNumber",
    label: (t) => t("fv-vin-search:VIN"),
    placeholder: (t) => t("fv-vin-search:Search VIN"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: "vins",
  },
  {
    queryKey: "shipmentId",
    label: (t) => t("fv-vin-search:Shipment ID"),
    placeholder: (t) => t("fv-vin-search:Search Shipment ID"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: "shipments",
  },
  {
    queryKey: "orderNumber",
    label: (t) => t("fv-vin-search:Order #"),
    placeholder: (t) => t("fv-vin-search:Search Order #"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: "orderNumbers",
  },
  {
    queryKey: "productTypeCategory",
    label: (t) => t("fv-vin-search:Product Type"),
    placeholder: (t) => t("fv-vin-search:Search Product Type"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    loaderProperty: "fetchProductTypeOptions",
    property: "productTypesOptions",
    loadingProperty: "productTypesOptionsLoading",
    itemLabelProperty: "label",
    itemValueProperty: "value",
  },
  {
    queryKey: "location",
    label: (t) => t("fv-vin-search:Location"),
    placeholder: (t) => t("fv-vin-search:Search Location"),
    transformFilterValue: (queryParameter, filterValue) => {
      const extractedFilterValue = extractBracketedAndNonBracketed(filterValue);
      return getCategorySearchRequestBody(queryParameter, extractedFilterValue);
    },
    queryBuilder: (queryKey, filterValue) => {
      return getBasicQueryString(queryKey, filterValue);
    },
    loaderProperty: "fetchLocationOptions",
    property: "locationOptions",
    loadingProperty: "locationOptionsLoading",
    itemLabelProperty: "label",
    itemValueProperty: "value",
  },
  {
    queryKey: "lastMilestoneCategory",
    label: (t) => t("fv-vin-search:Last Milestone"),
    placeholder: (t) => t("fv-vin-search:Search Last Milestone"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: null,
  },
  {
    queryKey: "itssIdCategory",
    label: (t) => t("fv-vin-search:ITSS ID"),
    placeholder: (t) => t("fv-vin-search:ITSS ID"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: null,
    requiredFeatures: [Features.ITSS],
  },
  {
    queryKey: "routeIdCategory",
    label: (t) => t("fv-vin-search:Route ID"),
    placeholder: (t) => t("fv-vin-search:Search Route ID"),
    transformFilterValue: (queryParameter, filterValue) => {
      return getCategorySearchRequestBody(queryParameter, filterValue);
    },
    property: "routeIds",
  },
];
